export const featuresLocalStorageKey = "featureFlagOverrides";
